import {Sucursal} from "./Sucursal";
import {IServicioAdicional} from "./ServicioAdicional";
import {ICatalogo} from "./ICatalogo";
import {RecintoAduanal} from "./RecintoAduanal";
import dayjs from "dayjs";

interface IHorario {
    id: number
    horaEntrada: Date
    horaSalida: Date
    dias: ICatalogo[]
}

interface IAreaServicio {
    id: number
    nombre: string
    clasificacionID?: number
    esRadConCita: boolean
    esEadConCita: boolean
    esForanea: boolean
    sucursal: Sucursal
    serviciosAdicionales: IServicioAdicional[]
    horarios: IHorario[]
    areaServicioRadEadCedis:any
    recintoAduanal: RecintoAduanal[]
}

export class AreaServicio {
    grupoHorarios: string[];

    constructor(props: IAreaServicio) {
        Object.assign(this, props);
        this.grupoHorarios = [];
    }

    ObtenerGrupoHorarios(){
        this.grupoHorarios = [];

        this.horarios.forEach(h=> {
            const totalDias = h.dias.length;

            if(totalDias > 0){
                const variosDias = totalDias > 1;
                const primerDia = h.dias[0];
                const horaEntrada = dayjs(h.horaEntrada).format('HH:mm');
                const horaSalida = dayjs(h.horaSalida).format('HH:mm');

                if(variosDias){
                    const ultimoDia = h.dias[totalDias - 1];
                    if(localStorage.getItem("idioma")==='en-US'){
                        this.grupoHorarios.push(`${primerDia.etiquetaDia?.nombre} - ${ultimoDia.etiquetaDia?.nombre} from ${horaEntrada} to ${horaSalida}`)
                    }
                    else{
                        this.grupoHorarios.push(`${primerDia.nombre} - ${ultimoDia.nombre} de ${horaEntrada} a ${horaSalida}`)
                    }
                }
                else{
                    if(localStorage.getItem("idioma")==='en-US'){
                        this.grupoHorarios.push(`${primerDia.etiquetaDia?.nombre} from ${horaEntrada} to ${horaSalida}`)
                    }
                    else{
                        this.grupoHorarios.push(`${primerDia.nombre} de ${horaEntrada} a ${horaSalida}`)
                    }
                }
            }
        })
    }
}

export interface AreaServicio extends IAreaServicio {
}
